import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeeight-blog',
  templateUrl: './homeeight-blog.component.html',
  styleUrls: ['./homeeight-blog.component.scss']
})
export class HomeeightBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
